module.exports = __webpack_public_path__ + "img/down-triangle-lines-white.2a0e23a7.svg";